import * as React from 'react';

import Widget from '../../Widget';

interface IComingSoonCardProps {
  title: string;
  /** What the section will show once it ships. */
  children: React.ReactNode;
  className?: string;
}

/** Placeholder card for a section that is not built yet: the title, a "Coming soon" label, and a short description. */
const ComingSoonCard = ({ title, children, className }: IComingSoonCardProps) => (
  <Widget className={className}>
    <Widget.Header
      className="gap-3"
      // A long title wraps beside the label rather than truncating.
      title={<span className="whitespace-normal">{title}</span>}
      trailing={<span className="text-warning-primary text-sm font-medium">Coming soon</span>}
    />
    <Widget.Body className="bg-primary text-secondary text-md p-5">{children}</Widget.Body>
  </Widget>
);

export default ComingSoonCard;
